<script setup lang="ts">
import logoMark from "@/assets/omni-logo-mark.webp";

defineProps<{ compact?: boolean }>();
</script>

<template>
  <div
    class="brand"
    :class="{ 'brand--compact': compact }"
    aria-label="Omni Portal"
  >
    <span class="brand__mark" aria-hidden="true">
      <img :src="logoMark" alt="" />
    </span>
    <span class="brand__wordmark">
      <strong>OMNI</strong>
      <span>PORTAL</span>
    </span>
  </div>
</template>

<style scoped>
.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.72rem;
  color: var(--brand-color, var(--color-ivory));
  letter-spacing: 0.04em;
}

.brand__mark {
  display: block;
  width: 2.8rem;
  height: 2.8rem;
  overflow: hidden;
  border-radius: 0.9rem;
}

.brand__mark img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(2.05);
}

.brand__wordmark {
  display: grid;
  gap: 0.06rem;
  font-size: 0.58rem;
  line-height: 1;
}

.brand__wordmark strong {
  font-size: 1.18rem;
  font-weight: 750;
  letter-spacing: 0.08em;
}

.brand__wordmark span {
  color: var(--brand-muted, #d7e6ff);
  letter-spacing: 0.08em;
}
.brand--compact .brand__wordmark {
  display: none;
}
.brand--compact .brand__mark {
  width: 2.35rem;
  height: 2.35rem;
}
</style>
